import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["deprecated", "deprecationMessage", "description", "footer", "title", "thumbnailOverlayed", "isFlushOnMobile", "isGhost", "name", "body", "onClick", "to", "use", "href", "hideDescription"];
import { useCallback } from 'react';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import HR from 'UIComponents/elements/HR';
import TrackCardLink from './TrackCardLink';
import { device } from '../../constants/StyledComponentConstants';
import { safeScrollTo } from 'LearningCenterUI/utils/utils';
import UICardHero from 'UIComponents/card/UICardHero';
import H4 from 'UIComponents/elements/headings/H4';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LineHeight = '24px';
const CardWrapper = styled(UICardWrapper).withConfig({
  displayName: "ContentCard__CardWrapper",
  componentId: "sc-2u7vwv-0"
})(["box-shadow:none;margin-bottom:0;overflow:hidden;color:", ";background-color:transparent;outline:8px solid transparent;transition:background-color 200ms,outline 200ms;&:hover{background-color:", ";outline:8px solid ", ";}&:not(:last-child){@media screen and ", "{margin-right:32px;flex-basis:auto;}}"], ({
  $isGhost
}) => $isGhost ? theme.colors.FLINT : 'inherit', ({
  $use
}) => $use === 'on-light' ? theme.colors.GYPSUM : 'transparent', ({
  $use
}) => $use === 'on-light' ? theme.colors.GYPSUM : 'transparent', device.mobile);
const CardSection = styled(UICardSection).attrs({
  className: 'card-section'
}).withConfig({
  displayName: "ContentCard__CardSection",
  componentId: "sc-2u7vwv-1"
})(["display:flex;flex-direction:column;padding:20px 0 20px;flex:2;@media screen and ", "{", ";}"], device.mobile, ({
  $isFlushOnMobile
}) => $isFlushOnMobile ? `padding: 20px 12px` : '');
const CardTitle = styled(H4).withConfig({
  displayName: "ContentCard__CardTitle",
  componentId: "sc-2u7vwv-2"
})(["margin-bottom:0;font-weight:500;"]);
const CardBody = styled.div.withConfig({
  displayName: "ContentCard__CardBody",
  componentId: "sc-2u7vwv-3"
})(["flex:1 1 ", ";line-height:", ";"], LineHeight, LineHeight);
const CardBodyInner = styled.div.withConfig({
  displayName: "ContentCard__CardBodyInner",
  componentId: "sc-2u7vwv-4"
})(["@media screen and ", "{min-height:calc(", " * 4 + 8px);}@media screen and ", "{min-height:calc(", " * 3 + 8px);}"], device.not.tablet, LineHeight, device.desktop, LineHeight);
const CardFooter = styled.div.withConfig({
  displayName: "ContentCard__CardFooter",
  componentId: "sc-2u7vwv-5"
})(["max-height:17px;line-height:1.3;"]);
const ColoredHR = styled(HR).withConfig({
  displayName: "ContentCard__ColoredHR",
  componentId: "sc-2u7vwv-6"
})(["background-color:", ";"], ({
  $isGhost
}) => $isGhost ? theme.colors.KOALA : theme.colors.GREAT_WHITE);
const ContentCard = _ref => {
  let {
      deprecated = false,
      deprecationMessage,
      description,
      footer,
      title,
      thumbnailOverlayed,
      isFlushOnMobile = true,
      isGhost = false,
      name,
      body,
      onClick,
      to,
      use = 'on-light',
      href,
      hideDescription: hideDescriptionProp
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const clickHandler = useCallback(() => {
    if (onClick) {
      onClick();
    }
    if (!deprecated && !href) {
      safeScrollTo(window, 0, 0);
    }
  }, [onClick, deprecated, href]);
  const hideDescription = hideDescriptionProp || !description;
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    $isGhost: isGhost || deprecated,
    $use: use,
    className: "content-card",
    compact: true,
    "data-test-id": "track-card",
    "data-test-is-ghost": isGhost
    // @ts-expect-error onCLick is handled by this component
    ,
    onClick: clickHandler,
    style: isMobile ? {
      borderRadius: 0
    } : undefined
  }, props, {
    children: /*#__PURE__*/_jsxs(TrackCardLink, {
      deprecated: deprecated,
      href: href,
      to: to,
      children: [thumbnailOverlayed && /*#__PURE__*/_jsx(UICardHero, {
        children: thumbnailOverlayed
      }), /*#__PURE__*/_jsxs(CardSection, {
        $isFlushOnMobile: isFlushOnMobile,
        flush: true,
        children: [/*#__PURE__*/_jsxs(CardTitle, {
          children: [name, title]
        }), !hideDescription && /*#__PURE__*/_jsx(ColoredHR, {
          $isGhost: isGhost || deprecated
        }), (!hideDescription || body || deprecationMessage) && /*#__PURE__*/_jsx(CardBody, {
          children: /*#__PURE__*/_jsxs(CardBodyInner, {
            children: [body, !hideDescription && (deprecated ? deprecationMessage : description && /*#__PURE__*/_jsx(UITruncateMultiline, {
              maxChars: 150,
              text: description || ''
            }))]
          })
        }), /*#__PURE__*/_jsx(CardFooter, {
          children: footer
        })]
      })]
    })
  }));
};
export default ContentCard;